import React, {useEffect, useMemo, useRef} from 'react'
import PropTypes from 'prop-types'
import useEffectEvent from '../../hooks/use-effect-event'
import useMultiSite from '../../hooks/use-multi-site'
import {useKlarna} from './context'

const KlarnaPayLater = ({amount, placement}) => {
    const {locale} = useMultiSite()
    const {loadKlarna, options, refreshPlacement} = useKlarna()
    const isEnabled = Boolean(options.enabled && amount > 0 && placement)
    const klarnaLocale = useMemo(() => locale.id.replace('_', '-'), [locale])
    const klarnaRef = useRef()
    const klarnaAmount = useMemo(() => {
        // TODO: klarna amount should be in the smallest denomination of the currency - for now consider all currencies in cents
        return amount * 100
    }, [amount])

    // load klarna on mount
    const onKlarnaEnabled = useEffectEvent(() => {
        loadKlarna()
    })
    useEffect(() => {
        if (isEnabled) {
            onKlarnaEnabled()
        }
    }, [isEnabled, onKlarnaEnabled])

    // update klarna amount on change
    const onAmountChange = useEffectEvent((klarnaAmount) => {
        if (klarnaRef.current?.dataset) {
            klarnaRef.current.dataset.purchaseAmount = klarnaAmount
        }
        refreshPlacement()
    })
    useEffect(() => {
        if (isEnabled && klarnaRef.current) {
            onAmountChange(klarnaAmount)
        }
    }, [isEnabled, klarnaAmount, onAmountChange])

    if (!isEnabled) {
        return null
    }

    return (
        <klarna-placement
            ref={klarnaRef}
            data-testid="klarna-placement"
            data-key={placement}
            data-locale={klarnaLocale}
            data-purchase-amount={klarnaAmount}
        />
    )
}

KlarnaPayLater.propTypes = {
    amount: PropTypes.number,
    placement: PropTypes.string
}

export default KlarnaPayLater
